<template>
  <div class="wrapper" :style="{ backgroundColor: color }">
    <SuccessApplicationCard />
    <img
      v-if="utm_source === 'talent.com'"
      alt="facebook-pixel"
      src="https://ca.talent.com/tracker/img-pixel.php?tracker=recrutei"
      hidden
    />
  </div>
</template>

<script>
import SuccessApplicationCard from "../../components/application-cards/SuccessApplicationCard.vue";
import { mapState } from "vuex";
import { readUtm } from "@/utils/utmStorage";

export default {
  data: () => ({
    utm_source: ""
  }),
  created() {
    this.utm_source = readUtm("utm_source") || "";
  },
  components: {
    SuccessApplicationCard
  },
  computed: {
    ...mapState("company", ["company"]),

    color() {
      return this.company.base_hexcolor || "#1551b1";
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/talent/pages/application.scss";
</style>
